
const { ccclass, menu, property, executeInEditMode, inspector, requireComponent } = cc._decorator;

@ccclass
@menu('custom/CustomSprite')
@executeInEditMode
export default class CustomSprite extends cc.Sprite {

    @property(cc.SpriteFrame)
    spriteFrameHolder: cc.SpriteFrame = null

    @property(cc.Boolean)
    reverse: boolean = false

    protected m_reverse: boolean = false
    protected m_spriteFrameHolder: cc.SpriteFrame = null
    onLoad(){
        this.refreshSpriteFame()
    }

    protected reCalcUV(){        
        if(this.spriteFrame){   
            let srcRect = this.spriteFrame.getRect()
            let rect = this.reverse? new cc.Rect(srcRect.x + srcRect.width - this.node.width, srcRect.y, this.node.width, srcRect.height): new cc.Rect(srcRect.x, srcRect.y, this.node.width, srcRect.height) 
            this.spriteFrame.setRect(rect)
        }        
    }

    setVertsDirty(){
        this.reCalcUV()
        super['setVertsDirty']()
    }


    refreshSpriteFame(){
        if(this.spriteFrameHolder){
            this.spriteFrame = this.spriteFrameHolder.clone()
            this.m_spriteFrameHolder = this.spriteFrameHolder
        }
    }

    update(dt){
        if(!this.spriteFrameHolder){
            this.spriteFrame = null
        }
        if(this.m_reverse != this.reverse){
            this.m_reverse = this.reverse
            this.reCalcUV()
        }
        if(this.m_spriteFrameHolder != this.spriteFrameHolder){
            this.refreshSpriteFame()
        }        
    }


}